import * as React from 'react';
import { withNodeResizable } from '../shared/NodeResizable';
import { Portal } from '../shared/Portal';
import { createEmbedExtension } from '../shared/createEmbedExtension';
import { EmbedRendererProps } from '../shared/types';

const URL_REGEX = new RegExp(
  '^https?://datastudio.google.com/(embed|u/0)/reporting/(.*)/page/(.*)(/edit)?$',
);
export const ENABLED = [URL_REGEX];

export const Component = ({ url, ...rest }: EmbedRendererProps<any>) => {
  const newUrl = React.useMemo(
    () => url.replace('u/0', 'embed').replace('/edit', ''),
    [url],
  );

  return (
    <Portal
      {...rest}
      url={newUrl}
      title="Google Data Studio"
      fullHeight
      withMetadata
    />
  );
};

export default createEmbedExtension({
  regexp: [URL_REGEX],
  name: 'google-data-studio-embed',
  component: withNodeResizable(Component, {
    lockAspectRatio: true,
    defaultHeight: 500,
  }),
  addCommandOption: {
    title: 'Google Data Studio',
    description: 'Embed a Google Data Studio report.',
    searchTerms: ['embed', 'google', 'data studio'],
    icon: 'logos:google-data-studio',
  },
});
